import { Link } from 'react-router-dom';

export default function CareersPage() {
  return (
    <div className="bg-black text-white min-h-screen">
      <nav className="bg-[#050a14]/95 backdrop-blur-md shadow-lg border-b border-[#1e3a8a]/10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <img src="https://static.readdy.ai/image/7302b421718742a693240adfeb05edc7/5b9e3cd7f2338041e3bb6bb21e39ce32.jpeg" alt="Nexora Corp" className="h-20 w-auto" />
          </Link>
          <div className="flex items-center gap-4">
            <a href="https://calendly.com/nexorasolutions/30min" target="_blank" rel="noopener noreferrer" className="bg-[#0a1628] hover:bg-[#0d1e38] border border-[#1e3a8a]/50 text-white px-6 py-2.5 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-[#1e3a8a]/20 whitespace-nowrap cursor-pointer text-sm font-medium">Book a Demo</a>
          </div>
        </div>
      </nav>

      <main className="flex items-center justify-center px-6 py-32">
        <div className="max-w-2xl text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">Join Our Team</h1>
          
          <p className="text-xl md:text-2xl text-white/70 mb-12 leading-relaxed">
            Interested in working with Nexora Corp?<br />
            Click below to apply.
          </p>

          <a 
            href="https://forms.gle/pBtz1yRbicnBqJ3L7" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#0a1628] hover:bg-[#0d1e38] border border-[#1e3a8a]/50 text-white px-10 py-4 rounded-full text-lg font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-[#1e3a8a]/20 cursor-pointer whitespace-nowrap"
          >
            Apply Now
            <i className="ri-arrow-right-line"></i>
          </a>

          <div className="mt-16">
            <Link to="/" className="text-white/70 hover:text-white transition-colors cursor-pointer inline-flex items-center gap-2">
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </main>

      <footer className="bg-[#050a14] border-t border-[#1e3a8a]/10 py-8">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-sm text-white/60">© 2025 Nexora Corp. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
